import toast from "react-hot-toast";
import { setUser } from "../redux/slices/profileSlice";
import { userDetail } from "../services/operations/profileApi";

const updateUserLocalStorage = async (dispatch) => {
    try {
        const userDetailsResponse = await userDetail();
        if (!userDetailsResponse.data.success) {
            return toast.error(userDetailsResponse.data.message);
        }
        dispatch(setUser(userDetailsResponse.data.user));
        localStorage.setItem('user', JSON.stringify(userDetailsResponse.data.user));
    } catch (error) {
        toast.error('Live reload failed, please log in again');
    }
};
export default updateUserLocalStorage;